<template>
  <div class="page">
    <!-- <nut-navbar class="msg-nav-title"  @on-click-back="back" :rightShow="false">
      短信发送
    </nut-navbar> -->
    <div class="d_c">
        <p>短信发送</p>
        <span class="rt-pos" @click="back"></span>
    </div>
    <div class="msg-content">
        <nut-row :span="24" class="msg-content-chat" v-for="(item,index) in messageData" :key="index">
          <nut-col>
              <nut-row>
                  <nut-col :span="20" align="center">
                      <div class="flex-content">
                        <span>{{item.createTime}}</span>
                      </div>
                  </nut-col>
                  <nut-col :span="4" align="center">
                      <div class="flex-content">
                        <span v-if="item.smsStatus == 0">
                          处理中
                        </span>
                        <span v-else-if="item.smsStatus == 1">
                          成功
                        </span>
                        <span v-else>
                          失败
                        </span>
                      </div>
                  </nut-col>
              </nut-row>
              <nut-row>
                  <nut-col :span="3" align="center">
                      <div class="msg-content-img">
                        <img :src="message"/>
                      </div>
                  </nut-col>
                  <nut-col :span="21" align="left">
                      <div class="flex-content" >
                        <span>
                          {{item.content}}
                        </span>
                      </div>
                  </nut-col>
              </nut-row>
          </nut-col>
        </nut-row>
    </div>
    <div class="msg-bottom">
      <nut-row>
          <nut-col :span="4" align="center">
              <div class="flex-content">卡号</div>
          </nut-col>
          <nut-col :span="20">
              <div class="flex-content">{{iccid}}</div>
          </nut-col>
      </nut-row>
      <nut-row>
          <nut-col :span="4" align="center">
              <div class="flex-content">内容</div>
          </nut-col>
          <nut-col :span="16">
              <div class="flex-content-textarea">
                <textarea v-model="content"></textarea>
              </div>
          </nut-col>
          <nut-col :span="4" align="left" style="line-height: 38px;">
              <nut-button small class="msg-send" @click="sendMessage">发送</nut-button>
          </nut-col>
      </nut-row>
    </div>
  </div>
</template>
<script>
import { wxCardSmsRecord , wxCardSmsSend } from "@/api/api.js"; //获取发送记录
export default {
  name:'msgSend',
  data() {
    return {
      content:undefined,
      iccid:this.$route.query.iccid,
      messageData:[],
      message:require('../../assets/svg/send-message.svg'),
    };
  },
  computed: {},
  methods: {
    // 后退到上一页
    back(){
      this.$router.go(-1);
    },
    messageRecord(){
      let params = {
        iccid : this.iccid
      }
      wxCardSmsRecord(params).then(res=>{
        if(res.data.code == 200){
            this.messageData = res.data.data;
        }
      })
    },
    sendMessage(){
      if(!!this.content){
          let params = {
            iccid : this.iccid,
            content : this.content
          }
          let that = this;
          wxCardSmsSend(params).then(res=>{
            that.messageRecord();
          })
      }
    }
  },
  created() {
    this.messageRecord();
  },
  mounted(){
    window.document.title ="短信发送";
  }
};
</script>
<style scoped lang="less">
  .page{
    .d_c{
      text-align: center;
      height: 40px;
      line-height: 40px;
      background: #F94040;
      color: #fff;
      font-size: 18px;
      position: relative;
      .rt-pos{
        position: absolute;
        left: 20px;
        top:14px;
        width: 12px;
        height: 12px;
        border-top: 2px solid gainsboro;
        border-left: 2px solid gainsboro;
        transform: rotate(-45deg);
      }
    }
    .msg-nav-title{
      color: #fff;
      font-size: 18px;
      background-color: rgb(249, 64, 64);
      height: 40px;
      line-height: 40px;
    }
    .msg-content{
      .nut-row{
        height: 25px;
        line-height: 25px;
      }
      .msg-content-img{
        width: 30px;
      }
      .msg-content-chat{
        margin-top:10px ;
      }
    }
    
    .msg-bottom{
      color: #2e2d2d;
      font-size: 1.1em;
      height: 96px;
      background-color: #e1e1e1;
      margin: 0px;
      padding: 0px;
      width: 100%;
      position: fixed;
      bottom: 0px;
      z-index:1111;
      .nut-row{
        height:40px;
        line-height: 40px;
      }
      .flex-content-textarea{
        height: 38px;
        border: 1px solid #ececee;
        padding: 5px 20px 5px 10px;
        position: relative;
        background: rgb(255, 255, 255);
      }
      textarea{
        resize: none;
        width: 100%;
        border: none;
        outline: none;
        margin: 0;
        padding: 0;
        background: transparent;
        display: block;
      }
      .msg-send{
        height: 38px;
      }
    }

    
  }
</style>
